const DHLDeliveryTypeData: any = {
  forEu: [
    { v: "11", t: "ordering.deliveryMethods.11" },
    { v: "12", t: "ordering.deliveryMethods.12" },
  ],
  forNorwayAndorraSwitzerlandAndUnitedKingdom: [
    { v: "09", t: "ordering.deliveryMethods.09" },
    { v: "10", t: "ordering.deliveryMethods.10" },
  ],
  forOthers: [{ v: "10", t: "ordering.deliveryMethods.10" }],
};

const deliveryTypeData: any = {
  forFinland: [
    { v: "P01", t: "ordering.deliveryMethods.P01" },
    { v: "P04", t: "ordering.deliveryMethods.P04" },
    { v: "P06", t: "ordering.deliveryMethods.P06" },
  ],
  forEu: [...DHLDeliveryTypeData.forEu],
  forNorwayAndorraSwitzerlandAndUnitedKingdom: [
    ...DHLDeliveryTypeData.forNorwayAndorraSwitzerlandAndUnitedKingdom,
  ],
  forIloqUsaInc: [
    { v: "UPSN", t: "ordering.deliveryMethods.UPSN" },
    { v: "SEKO", t: "ordering.deliveryMethods.SEKO" },
  ],
  forOthers: [
    // disabled for now, enable once DHL is ok to be used for all countries
    // ...DHLDeliveryTypeData.forOthers,
    { v: "02", t: "ordering.deliveryMethods.02" }, // UPS Express Saver
  ],
};

deliveryTypeData.all = [
  ...deliveryTypeData.forFinland,
  ...deliveryTypeData.forEu,
  ...deliveryTypeData.forOthers,
  ...deliveryTypeData.forIloqUsaInc,
];

export default function deliveryTypes(): any {
  return deliveryTypeData;
}

export const DHLDeliveryTypeCodes: string[] = Object.keys(DHLDeliveryTypeData)
  .map((key) => {
    return DHLDeliveryTypeData[key].map((item: any) => item.v);
  })
  .flat();
